/**
 * Schema Zod per risposte API arricchite.
 *
 * Tipi che il server costruisce aggiungendo dati (es. info lavoratore
 * alle deleghe/disdette) e che il client valida con safeParse.
 */
import { z } from 'zod';
import { DelegaSchema } from './entities/delega.ts';
import { DisdettaSchema } from './entities/disdetta.ts';
import { CodaSchema } from './entities/coda.ts';
import { CassaCodeSchema, str } from './entities/common.ts';
import { StatoElaborazioneSchema } from './casse/storage.ts';

// Info lavoratore aggiunta dal server a deleghe/disdette
export const LavoratoreInfoSchema = z.object({
  cognome: z.string(),
  nome: z.string(),
  codiceFiscale: str,
  cellulare: str,
  telefono: str,
  dataNascita: str,
}).nullable();

export type LavoratoreInfo = z.infer<typeof LavoratoreInfoSchema>;

// Delega arricchita (liste presentate/daPresentare/confermate + code)
export const DelegaArricchitaSchema = DelegaSchema.extend({
  lavoratore: LavoratoreInfoSchema,
  dataNascitaLavoratore: str,
  statoLavoratore: str,
  dataCessazioneLavoratore: str,
  sindacatoLavoratore: str,
  operatoreNome: str,
  operatoreTerritorio: str,
});
export type DelegaArricchita = z.infer<typeof DelegaArricchitaSchema>;

// Disdetta arricchita (lista disdette)
export const DisdettaArricchitaSchema = DisdettaSchema.extend({
  lavoratore: LavoratoreInfoSchema,
});
export type DisdettaArricchita = z.infer<typeof DisdettaArricchitaSchema>;

// Coda con conteggio deleghe (per lista)
export const CodaConCountSchema = CodaSchema.extend({
  numDeleghe: z.number(),
});
export type CodaConCount = z.infer<typeof CodaConCountSchema>;

// Elaborazione deserializzata (API response, NON record DB)
export const ElaborazioneResponseSchema = z.object({
  id: z.number(),
  codice_fenice: z.number(),
  codice_cassa: CassaCodeSchema,
  anno: z.number(),
  mese: z.number(),
  tipo: z.string().nullable(),
  stato: StatoElaborazioneSchema,
  nome_tabella: str,
  errore: str,
  file_path: str,
  importato_at: str,
  created_at: z.string().optional(),
  stats: z.object({
    totaleLavoratori: z.number(),
    impreseNonTrovate: z.number().optional(),
  }).nullable(),
  warnings: z.array(z.string()).nullable(),
  importResult: z.record(z.unknown()).nullable(),
  /** True se questa riga e' il candidato unico per l'allineamento manuale del
   *  suo periodo (cassa multi-tipo solo_attivi, max id periodo, puoAllineare).
   *  Usato dal frontend per esporre il bottone "Allinea archivi" a livello riga. */
  allineabile: z.boolean().optional(),
});
export type ElaborazioneResponse = z.infer<typeof ElaborazioneResponseSchema>;
